import { Col, Row } from "antd"
import { DataSourceCard } from "src/pages/DataAssets/components/DataSourceCard"
import { DataSourceChoice } from "src/pages/DataAssets/drawers/NewAssetDrawer/NewAssetDrawer"
import { PaintedDoorDataSource } from "src/pages/DataAssets/getImageLogo"
import { NativeCloudSupportedDataSource } from "src/pages/DataAssets/schemas/data-source-schemas"

export const API_DS_API_HREF = "https://docs.greatexpectations.io/docs/cloud/connect/connect_python"

type DataSourceCardsProps = {
  setChoice: (choice: DataSourceChoice) => void
  isDSPaintedDoorEnabled?: boolean
}

const CLOUD_SUPPORTED_DATA_SOURCES = [
  {
    type: "SNOWFLAKE",
    onClick: undefined,
  },
  {
    type: "POSTGRES",
    onClick: undefined,
  },
  {
    type: "DATABRICKS_SQL",
    onClick: undefined,
  },
  {
    type: "REDSHIFT",
    onClick: undefined,
  },
]

const POSTGRES_FLAVOR_DATA_SOURCES = [
  {
    type: "NEON",
    onClick: undefined,
  },
  {
    type: "CITUS",
    onClick: undefined,
  },
  {
    type: "ALLOY",
    onClick: undefined,
  },
  {
    type: "AURORA",
    onClick: undefined,
  },
]

const API_SUPPORTED_DATA_SOURCES = [
  {
    type: "PANDAS_ABS",
    href: API_DS_API_HREF,
    onClick: undefined,
  },
  {
    type: "PANDAS_GCS",
    href: API_DS_API_HREF,
    onClick: undefined,
  },
  {
    type: "BIGQUERY",
    href: API_DS_API_HREF,
  },
  {
    type: "PANDAS_S3",
    href: API_DS_API_HREF,
    onClick: undefined,
  },
  {
    type: "PANDAS_FILESYSTEM",
    href: API_DS_API_HREF,
    onClick: undefined,
  },
  {
    type: "SPARK_FILESYSTEM",
    href: API_DS_API_HREF,
    onClick: undefined,
  },
]

const ROW_STYLE = {
  maxWidth: "700px",
} // FIXME: Mapping DSCard causes a weird side effect where the horizontal gap between cards is not respected.

export function DataSourceCards({ setChoice, isDSPaintedDoorEnabled }: DataSourceCardsProps) {
  const cloudSupportedDataSources = isDSPaintedDoorEnabled
    ? [...CLOUD_SUPPORTED_DATA_SOURCES, ...POSTGRES_FLAVOR_DATA_SOURCES]
    : CLOUD_SUPPORTED_DATA_SOURCES

  return (
    <>
      <Row gutter={[8, 8]} style={ROW_STYLE}>
        {cloudSupportedDataSources.map(({ type, onClick }) => (
          <Col span={8} key={type}>
            <DataSourceCard
              isDSPaintedDoorsEnabled={isDSPaintedDoorEnabled}
              type={type as NativeCloudSupportedDataSource}
              onClick={
                onClick
                  ? onClick
                  : (dataSourceType?: NativeCloudSupportedDataSource | PaintedDoorDataSource) =>
                      setChoice({ createNew: true, dataSourceType: dataSourceType as NativeCloudSupportedDataSource })
              }
            />
          </Col>
        ))}
        {isDSPaintedDoorEnabled &&
          API_SUPPORTED_DATA_SOURCES.map(({ type, href }) => (
            <Col span={8} key={type}>
              <DataSourceCard
                isDSPaintedDoorsEnabled={isDSPaintedDoorEnabled}
                href={href}
                type={type as NativeCloudSupportedDataSource}
              />
            </Col>
          ))}
      </Row>
    </>
  )
}
